module.exports = __webpack_public_path__ + "static/media/bolt.8a59920d.svg";